export default "__VITE_ASSET__Coz9Cqep__"